export const TIME = {
    MIN: "00:00",
    MAX: "23:50",
    THIRTY_MINUTES: 30 * 60 * 1000,
    ONE_MINUTES: 60 * 1000,    
}


export const DATETIME = {
    MIN: new Date(1000, 0, 1, 0, 0, 0)
}